import React, { useState } from 'react'
import { useIntl } from 'react-intl';
import { I18NContext } from '../i18n/i18nprovider';
import { ImSpinner6 } from "react-icons/im";
import { FaRegCheckCircle } from "react-icons/fa";

export type WebinarsPageProps = {};

export type Webinar = {
  id: string,
  title: {
    en: string,
    es?: string,
    pt?: string,
    zh?: string
  },
  date: string,
  duration: string,
  type: 'telecom' | 'electronics',
  time: string,
  body: {
    en: string,
    es?: string,
    pt?: string,
    zh?: string
  },
  footnote: {
    en: string,
    es?: string,
    pt?: string,
    zh?: string
  },
  regurl: string,
};

const webinars: Webinar[] = [
  {
    id: "a",
    title: {
      en: "Safety Rules",
      es: "Normas De Seguridad",
      pt: "Normas de Segurança",
      zh: "安全守则"
    },
    date: "10/06/2024",
    duration: "30 Min",
    type: "electronics",
    time: "10:00 am PSD",
    body: {
      en: "MCB is pleased to share with you the Safety Standards Webinar. For 30 minutes we will talk about the specifications and requirements to obtain compliance with the NOM-001-SCFI-2018, NOM-016-SCFI-1993 and NOM-019-SCFI-1998 standards. Learn about the field of application, certification requirements and keep your company one step ahead with up-to-date market information.<br />Register today to access our webinar and develop the correct strategies to use to achieve the greatest success of your business.",
      es: "MCB tiene el placer de compartir con usted el seminario web sobre normas de seguridad. Durante 30 minutos platicaremos sobre las especificaciones y requisitos para obtener el cumplimiento con las normas NOM-001-SCFI-2018, NOM-016-SCFI-1993 y NOM-019-SCFI-1998. Conozca el campo de aplicación, requisitos de certificación y mantenga a su empresa un paso adelante con la información actualizada del mercado.<br />Regístrese hoy para acceder a nuestro seminario web y desarrolle las estrategias correctas a utilizar para lograr el mayor éxito de su negocio.",
      pt: "A MCB tem o prazer de compartilhar com vocês o Webinar sobre Normas de Segurança. Durante 30 minutos falaremos sobre as especificações e requisitos para obter conformidade com as normas NOM-001-SCFI-2018, NOM-016-SCFI-1993 e NOM-019-SCFI-1998. Conheça o campo de aplicação, requisitos de certificação e mantenha sua empresa um passo à frente com informações atualizadas do mercado.<br />Inscreva-se hoje para acessar nosso webinar e desenvolver as estratégias corretas para alcançar o maior sucesso do seu negócio.",
      zh: "MCB 很高兴与您分享安全标准网络研讨会。我们将用 30 分钟的时间讨论符合 NOM-001-SCFI-2018、NOM-016-SCFI-1993 和 NOM-019-SCFI-1998 标准的规范和要求。了解应用领域、认证要求，并通过最新的市场信息让您的公司领先一步。<br />立即注册以访问我们的网络研讨会，并制定正确的策略以实现您的业务最大成功。 商业。"
    },
    footnote: {
      en: "If you are interested in a particular topic, you can send us your suggestion to respana@mexicocb.com.mx and if it is within our reach, we will gladly prepare the webinar so that it is within your reach.",
      es: "I le interesa algún tema en especial, nos puede enviar su sugerencia al correo respana@mexicocb.com.mx y si está dentro de nuestro alcance, con gusto preparamos el webinar para que este a su alcance.",
      pt: "Se você estiver interessado em um determinado tema, pode nos enviar sua sugestão para respana@mexicocb.com.mx e se estiver ao nosso alcance, teremos o prazer de preparar o webinar para que esteja ao seu alcance.",
      zh: "如果您对某个特定主题感兴趣，可以将您的建议发送至 respana@mexicocb.com.mx，如果在我们的能力范围内，我们将很乐意准备网络研讨会，以便您能够完成。"
    },
    regurl: "#"
  },
  {
    id: "b",
    title: {
      en: "Efficiency Standards",
      es: "Normas de Eficiencia",
      pt: "Padrões de Eficiência",
      zh: "效率标准",
    },
    date: "06/24/2024",
    duration: "30 Min",
    type: "electronics",
    time: "10:00 am PSD",
    body: {
      en: "MCB is pleased to share with you the Energy Efficiency Standards Webinar. For 30 minutes we will talk about the specifications and requirements to obtain compliance with the NOM-029-ENER-2017 and NOM-032-ENER-2013 standards. Learn about the field of application, certification requirements and keep your company one step ahead with up-to-date market information. Register today to access our webinar and develop the right strategies to use to achieve the greatest success for your business.",
      es: "MCB tiene el placer de compartir con usted el seminario web sobre normas de eficiencia energética. Durante 30 minutos platicaremos sobre las especificaciones y requisitos para obtener el cumplimiento con las normas NOM-029-ENER-2017 y NOM-032-ENER-2013. Conozca el campo de aplicación, requisitos de certificación y mantenga a su empresa un paso adelante con la información actualizada del mercado. Regístrese hoy para acceder a nuestro seminario web y desarrolle las estrategias correctas a utilizar para lograr el mayor éxito de su negocio.",
      pt: "A MCB tem o prazer de compartilhar com vocês o Webinar sobre Padrões de Eficiência Energética. Durante 30 minutos falaremos sobre as especificações e requisitos para obter conformidade com as normas NOM-029-ENER-2017 e NOM-032-ENER-2013. Conheça o campo de aplicação, requisitos de certificação e mantenha sua empresa um passo à frente com informações atualizadas do mercado. Cadastre-se hoje para acessar nosso webinar e desenvolver as estratégias certas para alcançar o maior sucesso para o seu negócio.",
      zh: "MCB 很高兴与您分享能源效率标准网络研讨会。我们将用 30 分钟的时间讨论符合 NOM-029-ENER-2017 和 NOM-032-ENER-2013 标准的规范和要求。了解应用领域、认证要求，并通过最新的市场信息让您的公司领先一步。立即注册以访问我们的网络研讨会，并制定正确的策略来为您的企业取得最大的成功。",
    },
    footnote: {
      en: "If you are interested in a particular topic, you can send us your suggestion to respana@mexicocb.com.mx and if it is within our reach, we will gladly prepare the webinar so that it is within your reach.",
      es: "I le interesa algún tema en especial, nos puede enviar su sugerencia al correo respana@mexicocb.com.mx y si está dentro de nuestro alcance, con gusto preparamos el webinar para que este a su alcance.",
      pt: "Se você estiver interessado em um determinado tema, pode nos enviar sua sugestão para respana@mexicocb.com.mx e se estiver ao nosso alcance, teremos o prazer de preparar o webinar para que esteja ao seu alcance.",
      zh: "如果您对某个特定主题感兴趣，可以将您的建议发送至 respana@mexicocb.com.mx，如果在我们的能力范围内，我们将很乐意准备网络研讨会，以便您能够完成。"
    },
    regurl: "#"
  },
  {
    id: "c",
    title: {
      en: "Telecommunications",
      es: "Telecomunicaciones",
      pt: "Telecomunicações",
      zh: "电信",
    },
    date: "04/05/2024",
    duration: "40 Min",
    type: "telecom",
    time: "10:00 am PSD",
    body: {
      en: "MCB is pleased to share with you the webinar on. Conformity Evaluation Procedure in telecommunications and broadcasting.<br />Requirements and schemes that refer to the Telecommunications area of ​​MCB. Register today to access our webinar and develop the right strategies to use to achieve the greatest success for your business.",
      es: "MCB tiene el placer de compartir con usted el seminario web sobre. Procedimiento de Evaluación de la Conformidad en materia de telecomunicaciones y radiodifusión.<br />Requisitos y esquemas que hacen referencia al área de Telecomunicaciones de MCB. Regístrese hoy para acceder a nuestro seminario web y desarrolle las estrategias correctas a utilizar para lograr el mayor éxito de su negocio.",
      pt: "O MCB tem o prazer de compartilhar com vocês o webinar sobre. Procedimento de Avaliação da Conformidade em Telecomunicações e Radiodifusão.<br />Requisitos e esquemas referentes à área de Telecomunicações do MCB. Cadastre-se hoje para acessar nosso webinar e desenvolver as estratégias certas para alcançar o maior sucesso para o seu negócio.",
      zh: "MCB 很高兴与您分享本次网络研讨会。电信和广播的合格评定程序。<br />参考 MCB 电信领域的要求和方案。立即注册以访问我们的网络研讨会，并制定正确的策略来为您的企业取得最大的成功。",
    },
    footnote: {
      en: "If you are interested in a particular topic, you can send us your suggestion to respana@mexicocb.com.mx and if it is within our reach, we will gladly prepare the webinar so that it is within your reach.",
      es: "I le interesa algún tema en especial, nos puede enviar su sugerencia al correo respana@mexicocb.com.mx y si está dentro de nuestro alcance, con gusto preparamos el webinar para que este a su alcance.",
      pt: "Se você estiver interessado em um determinado tema, pode nos enviar sua sugestão para respana@mexicocb.com.mx e se estiver ao nosso alcance, teremos o prazer de preparar o webinar para que esteja ao seu alcance.",
      zh: "如果您对某个特定主题感兴趣，可以将您的建议发送至 respana@mexicocb.com.mx，如果在我们的能力范围内，我们将很乐意准备网络研讨会，以便您能够完成。"
    },
    regurl: "#"
  },
  {
    id: "d",
    title: {
      en: "DT IFT-012 and DT IFT-011 Part 3",
      es: "DT IFT-012 y DT IFT-011 Parte 3",
      pt: "DT IFT-012 e DT IFT-011 Parte 3",
      zh: "DT IFT-012 和 DT IFT-011 第 3 部分",
    },
    date: "01/19/2024",
    duration: "40 Min",
    type: "telecom",
    time: "10:00 am PSD",
    body: {
      en: "We will discuss the scope of the technical provisions (DT) DT IFT-012 and DT IFT-011 Part 3 You will know the field of application, certification requirements so that you have the most complete information and are one of the largest certification providers for Telecommunications. Register today to access our webinar and develop the right strategies to use to achieve the greatest success for your business",
      es: "Trataremos sobre el alcance de las disposiciones técnicas (DT) DT IFT-012 y DT IFT-011 Parte 3 Conocerá el campo de aplicación, requisitos de certificación para que tenga la información más completa y sea uno de los mayores proveedores de certificación para Telecomunicaciones. Regístrese hoy para acceder a nuestro seminario web y desarrolle las estrategias correctas a utilizar para lograr el mayor éxito de su negocio",
      pt: "Discutiremos o escopo das disposições técnicas (DT) DT IFT-012 e DT IFT-011 Parte 3 Você conhecerá o campo de aplicação, requisitos de certificação para que tenha as informações mais completas e seja um dos maiores fornecedores de certificação para Telecomunicações. Cadastre-se hoje para acessar nosso webinar e desenvolver as estratégias certas para alcançar o maior sucesso para o seu negócio",
      zh: "我们将讨论技术条款（DT）DT IFT-012和DT IFT-011第3部分的范围您将了解应用领域、认证要求，使您拥有最完整的信息，成为最大的认证提供商之一电信。立即注册以访问我们的网络研讨会并制定正确的策略，以帮助您的企业取得最大的成功",
    },
    footnote: {
      en: "If you are interested in a particular topic, you can send us your suggestion to respana@mexicocb.com.mx and if it is within our reach, we will gladly prepare the webinar so that it is within your reach.",
      es: "I le interesa algún tema en especial, nos puede enviar su sugerencia al correo respana@mexicocb.com.mx y si está dentro de nuestro alcance, con gusto preparamos el webinar para que este a su alcance.",
      pt: "Se você estiver interessado em um determinado tema, pode nos enviar sua sugestão para respana@mexicocb.com.mx e se estiver ao nosso alcance, teremos o prazer de preparar o webinar para que esteja ao seu alcance.",
      zh: "如果您对某个特定主题感兴趣，可以将您的建议发送至 respana@mexicocb.com.mx，如果在我们的能力范围内，我们将很乐意准备网络研讨会，以便您能够完成。"
    },
    regurl: "#"
  },
];

export type WebinarRegForm = {
  name: string,
  company: string,
  email: string,
  tel?: string
}

export enum WebinarRegFormStep {
  NOT_STARTED = 'not-started',
  PROCESS = "process",
  FINISHED = "finished"
}

const WebinarsPage: React.FC<WebinarsPageProps> = () => {
  const { lang } = React.useContext(I18NContext);
  const intl = useIntl();
  const [curId, setCurId] = useState<string>('a');
  const [regStep, setRegStep] = useState<WebinarRegFormStep>(WebinarRegFormStep.NOT_STARTED);
  const [regForm, setRegForm] = useState<WebinarRegForm>({
    name: '',
    company: '',
    email: '',
    tel: ''
  })

  const clearRegForm = () => {
    setRegForm({
      name: '',
      company: '',
      email: '',
      tel: ''
    });
  }

  const handleFormChange = (key: 'name' | 'company' | 'email' | 'tel', value: string) => {
    let _regForm = {...regForm};
    _regForm[key] = value;
    setRegForm(_regForm);
  }

  const postForm = async (id: string) => {
    setRegStep(WebinarRegFormStep.PROCESS);
    await fetch('https://hooks.zapier.com/hooks/catch/15164005/37scehl/', {
      method: 'post',
      body: JSON.stringify({...regForm, webinarData: {...(webinars.filter(webn => webn.id === id)[0])}})
    });
    setTimeout(() => {
      setRegStep(WebinarRegFormStep.FINISHED)
    }, 1000);
  }

  const handleClick = (id: string) => {
    console.log(curId, id);
    clearRegForm();
    setRegStep(WebinarRegFormStep.NOT_STARTED);
    setCurId(id);
  }

  return (
    <div className="w-full max-w-7xl flex flex-col md:flex-row m-auto md:mt-4">
      <div className="w-full md:w-80 bg-bleh">
        <div className="w-full p-6 px-10">
          <img src="/mcb.svg" alt="" className='w-full max-w-xs m-auto'/>
        </div>
        <div className="w-full bg-main text-secondary">
          <h2 className='uppercase text-center font-bold text-3xl'>
            {
              intl.formatMessage({
                id: 'webinars'
              })
            }
          </h2>
        </div>
        <div className="hidden w-full md:flex flex-col p-4">
          <h2 className='text-md font-semibold'>
            {
              intl.formatMessage({
                id: 'webn-elect'
              })
            }
          </h2>
          {webinars.filter((webn) => webn.type === 'electronics').map((webn) => (
            <div 
              className={`w-full border-b border-gray-500 mb-2 cursor-pointer text-main pl-2 ${curId === webn.id ? 'font-bold' : ''}`}
              onClick={() => {handleClick(webn.id)}}
            >
              <h3>{webn.title[lang]}</h3>
              <p className='text-sm w-full flex pl-2'>
                <span className="w-1/3">
                  {intl.formatMessage({
                    id: 'date'
                  })}
                </span>
                <span>{webn.date}</span>
              </p>
              <p className='text-sm w-full flex pl-2'>
                <span className="w-1/3">
                  {intl.formatMessage({
                    id: 'duration'
                  })}
                </span>
                <span>{webn.duration}</span>
              </p>
            </div>
          ))}
          <h2 className='text-md font-semibold'>
            {
              intl.formatMessage({
                id: 'webn-tele'
              })
            }
          </h2>
          {webinars.filter((webn) => webn.type === 'telecom').map((webn) => (
            <div 
              className={`w-full border-b border-gray-500 mb-2 cursor-pointer text-main pl-2 ${curId === webn.id ? 'font-bold' : ''}`}
              onClick={() => {handleClick(webn.id)}}
            >
              <h3>{webn.title[lang]}</h3>
              <p className='text-sm w-full flex pl-2'>
                <span className="w-1/3">
                  {intl.formatMessage({
                    id: 'date'
                  })}
                </span>
                <span>{webn.date}</span>
              </p>
              <p className='text-sm w-full flex pl-2'>
                <span className="w-1/3">
                  {intl.formatMessage({
                    id: 'duration'
                  })}
                </span>
                <span>{webn.duration}</span>
              </p>
            </div>
          ))}
        </div>

      </div>
      {
        webinars.map((webn) => (
          <div className={`w-full h-full px-6 ${curId === webn.id ? 'block' : 'block md:hidden'}`}>
            <h2 className='text-secondary font-bold text-xl'>
              {webn.title[lang]}
            </h2>
            <p className='whitespace-pre-wrap py-6' dangerouslySetInnerHTML={{
              __html: (webn.body[lang] as string)
            }}></p>
            <p>
              {
                intl.formatMessage({
                  id: 'date'
                })
              }
              &nbsp;:&nbsp;
              {webn.date}
            </p>
            <p>
              {
                intl.formatMessage({
                  id: 'time'
                })
              }
              &nbsp;:&nbsp;
              {webn.time}
            </p>
            <p>
              {
                intl.formatMessage({
                  id: 'duration'
                })
              }
              &nbsp;:&nbsp;
              {webn.duration}
            </p>
            <div className="mt-6">
              {webn.footnote[lang]}
            </div>
            <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-md my-4 max-w-sm min-h-64">
              {regStep === WebinarRegFormStep.NOT_STARTED && (
                <>
                <label className="flex flex-col w-full" htmlFor="name">
                  <span className='text-sm'>
                    {
                      intl.formatMessage({id: 'name'})
                    }
                  </span>
                  <input type="text" name="name" value={regForm.name} onChange={(e) => {handleFormChange('name', e.target.value)}} />
                </label>
                <label className="flex flex-col w-full" htmlFor="company">
                  <span className='text-sm'>
                    {
                      intl.formatMessage({id: 'company'})
                    }
                  </span>
                  <input type="text" name="company" value={regForm.company} onChange={(e) => {handleFormChange('company', e.target.value)}} />
                </label>
                <label className="flex flex-col w-full" htmlFor="email">
                  <span className='text-sm'>
                    {
                      intl.formatMessage({id: 'email'})
                    }
                  </span>
                  <input type="text" name="email" value={regForm.email} onChange={(e) => {handleFormChange('email', e.target.value)}} />
                </label>
                <button 
                  className="bg-secondary text-white uppercase py-2 px-4 rounded-md mt-6"
                  onClick={() => {postForm(webn.id)}}
                >
                  {
                    intl.formatMessage({
                      id: 'reg-now'
                    })
                  }
                </button>
              </>
              )}
              {regStep === WebinarRegFormStep.PROCESS && (
                <>
                  <ImSpinner6 size={80} className=' animate-spin text-gray-400'/>
                </>
              )}
              {regStep === WebinarRegFormStep.FINISHED && (
                <>
                  <FaRegCheckCircle size={80} className=' text-gray-400'/>
                  <span className='text-gray-400 text-center mt-3'>
                    {
                      intl.formatMessage({
                        id: 'thanks-reg'
                      })
                    }
                  </span>
                </>
              )}
            </div>
          </div>   
        ))
      }
    </div>
  );
}

export default WebinarsPage;